import * as React from "react";
import { Grid } from "@mui/material";

interface OrderDetailsSubbarProps {
  start: React.ReactElement;
  end: React.ReactElement;
}

const OrderDetailsSubbar: React.FC<OrderDetailsSubbarProps> = (props) => {
  const { start, end } = props;
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          {start}
        </Grid>
        <Grid item xs={4} sx={{ textAlign: "right" }}>
          {end}
        </Grid>
      </Grid>
    </>
  );
};

export default OrderDetailsSubbar;
